<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="Search" @change="FilterItems"></el-input>
        </el-form-item>

        <el-form-item label="Column Chooser">
          <el-select v-model="columnSelection" multiple collapse-tags placeholder="Select"
            @change="columnsSelectionChanged" width="200px">
            <el-option v-for="item in columnOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>


        <!-- <el-form-item label="Compensator">
          <el-checkbox v-model="columns.compensator"></el-checkbox>
        </el-form-item>
        <el-form-item label="Target Position" style="margin-left: 40px">
          <el-checkbox v-model="columns.targetPos"></el-checkbox>
        </el-form-item>
        <el-form-item label="Software Version" style="margin-left: 40px">
          <el-checkbox v-model="columns.softwareVersion" @change="columnsSelectionChanged"></el-checkbox>
        </el-form-item>
        <el-form-item label="Billing Due" style="margin-left: 40px">
          <el-checkbox v-model="columns.billingDue" @change="columnsSelectionChanged"></el-checkbox>
        </el-form-item> -->
        <el-form-item label="Boro" style="margin-left: 40px">
          <el-select v-model="boroSelection" multiple placeholder="Select" @change="FilterItems">
            <el-option v-for="item in boroOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="allowManage" style="margin-left: 40px">
          <el-button type="primary" @click="goToManageZones">Manage Zones</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="zones" highlight-current-row v-loading="listLoading" style="width: 100%"
      @row-click="zoneActivateClick">
      <el-table-column prop="gsd_id" label="Zone ID" sortable></el-table-column>
      <el-table-column prop="name" label="Zone Name" width="300" sortable></el-table-column>
      <el-table-column prop="status" label="Status" sortable></el-table-column>
      <el-table-column prop="oat" label="Outdoor Temp"></el-table-column>
      <el-table-column v-if="columns.targetPos" prop="targetPosition" label="Target Pos"></el-table-column>
      <el-table-column prop="currentPosition" label="Current Pos"></el-table-column>
      <el-table-column v-if="columns.temperatureReturn" prop="temperatureReturnLine"
        label="Return Temperature"></el-table-column>
      <el-table-column v-if="columns.pressureReturn" prop="pressureReturn" label="Return Pressure"></el-table-column>
      <el-table-column v-if="columns.softwareVersion" prop="softwareVersion" label="Software Version"></el-table-column>
      <el-table-column prop="mode" label="Mode">
        <template slot-scope="scope">
          <div v-if="scope.row.mode == 'Manual'">Valve Set</div>
          <div v-else-if="scope.row.mode == 'ValveSet'">Manual</div>
          <div v-else>{{ scope.row.mode }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="columns.compensator" prop="compensator" label="Compensator"></el-table-column>
      <el-table-column v-if="columns.billingDue" label="Next Billing" width="350">
        <template scope="scope">
          <div v-if="scope.row.billingDue"><el-tag type="danger">{{ scope.row.nextBillingAt }}</el-tag></div>
          <div v-else><el-tag type="success">{{ scope.row.nextBillingAt }}</el-tag></div>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total"
        style="float: right"></el-pagination>
    </el-col>
    <!--Zone management -->
  </section>
</template>

<script>
import Axios from "axios"
import UserService from "@/api/user.service"
import dateFormat from "dateformat"

export default {
  computed: {
    allowManage() {
      return this.user.role == "admin"
    },
  },
  data() {
    return {
      user: this.$session.get("User"),
      boroOptions: [],
      boroSelection: [],

      columnOptions: [
        {
          value: 'compensator',
          label: 'Compensator'
        },
        {
          value: 'targetPosition',
          label: 'Target Position'
        },
        {
          value: 'softwareVersion',
          label: 'Software Version'
        },
        {
          value: 'billingDue',
          label: 'Billing Due'
        },
        {
          value: 'temperatureReturn',
          label: 'Temperature - Return'
        },
        {
          value: 'pressureReturn',
          label: 'Pressure - Return'
        },
        {
          value: 'zoneSerialNumber',
          label: 'Zone Serial Number'
        },
      ],
      columnSelection: [],


      columns: {
        compensator: false,
        targetPos: false,
        boro: false,
        zoneID: false,
        softwareVersion: false,
        billingDue: false,
        pressureReturn: false,
        temperatureReturn: false
      },
      polling: null,
      filters: {
        name: ""
      },
      zones: [],
      allzones: [],
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      user: this.$session.get("User"),
      zoneDialog: {
        title: "",
        visible: false,
        loading: false,
        showPanelID: false,
        form: {
          name: "",
          deviceID: ""
        }
      }
    }
  },
  methods: {
    columnsSelectionChanged() {
      console.log("columns selection changed")
      console.log(this.columnSelection)
      this.columns.compensator = this.columnSelection.indexOf('compensator') >= 0
      this.columns.targetPos = this.columnSelection.indexOf('targetPosition') >= 0
      this.columns.zoneID = this.columnSelection.indexOf('zoneSerialNumber') >= 0
      this.columns.softwareVersion = this.columnSelection.indexOf('softwareVersion') >= 0
      this.columns.billingDue = this.columnSelection.indexOf('billingDue') >= 0
      this.columns.pressureReturn = this.columnSelection.indexOf('pressureReturn') >= 0
      this.columns.temperatureReturn = this.columnSelection.indexOf('temperatureReturn') >= 0
      localStorage.setItem("columnChooserSelection", JSON.stringify(this.columnSelection));
    },
    editZone(value) {
      console.log("edditing")
      console.log(value)
    },
    FilterItems() {
      console.log("here")
      localStorage.setItem("zoneFilter", this.filters.name);
      localStorage.setItem("boroSelection", JSON.stringify(this.boroSelection));
      if (this.filters.name.length > 0) {
        //Save the filter in the session        
        this.zones = this.allzones.filter(
          (zone) =>
            (this.boroSelection.length == 0 || this.boroSelection.includes(zone.boro)) &&
            (zone.name.toLowerCase().includes(this.filters.name.toLowerCase()) || zone.gsd_id.toLowerCase().includes(this.filters.name.toLowerCase()))
        )
      } else {
        this.zones = this.allzones.filter((zone) => this.boroSelection.length == 0 || this.boroSelection.includes(zone.boro))
      }
    },
    handleCurrentChange() { },
    goToManageZones() {
      this.$router.push("/Zones")
    },
    zoneActivateClick(row) {
      console.log(this.user)
      UserService.switchZone(row.id, this.user.email).then((response) => {
        UserService.getUser(this.user.email).then((response) => {
          if (response.data.error == null) {
            this.$session.set("User", response.data)
            this.$root.$emit("zoneChanged", row.id)
            this.$router.push("/Dashboard")
            console.log(row.id)
          }
        })
      })
    },
    getZones() {
      this.listLoading = true
      Axios.all([UserService.getZonesEx(this.user.email)]).then(
        Axios.spread((zonesResponse) => {
          this.listLoading = false
          let unique = [...new Set(zonesResponse.data.map((item) => item.boro))]
          this.boroOptions = []
          unique.forEach((element) => {
            this.boroOptions.push({
              value: element,
              label: element
            })
          })
          this.allzones = zonesResponse.data
          for (var zone of this.allzones) {
            console.log(zone)
            zone.billingDue = false;
            zone.nextBillingAt = ""

            if (zone.next_billing_at) {
              console.log(zone.billing_due)
              zone.nextBillingAt = dateFormat(zone.next_billing_at, "yyyy-mm-dd")
              zone.billingDue = zone.billing_due == 1
            }
          }
          if (localStorage.getItem("zoneFilter") && localStorage.getItem("zoneFilter").length > 0) {
            this.filters.name = localStorage.getItem("zoneFilter")
          }
          if (localStorage.getItem("columnChooserSelection")) {
            this.columnSelection = JSON.parse(localStorage.getItem("columnChooserSelection"))
          }
          if (localStorage.getItem("boroSelection")) {
            this.boroSelection = JSON.parse(localStorage.getItem("boroSelection"))
          }
          this.FilterItems()
        })
      )
    }
  },
  mounted() {
    this.getZones()
    this.polling = setInterval(this.getZones, 60000)
  },
  beforeDestroy() {
    clearInterval(this.polling)
  }
}
</script>

<style>
.el-table td {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ZonesDashboard.vue?d67d1b3c